/* DOBLE TESORO — interacciones (vanilla, sin dependencias) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  function initReveal() {
    var els = document.querySelectorAll('.dt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('[data-dt-parallax]');
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-dt-parallax')) || 0;
        var y = Math.min(window.scrollY, window.innerHeight) * k;
        img.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initCalc() {
    document.querySelectorAll('[data-dt-calc]').forEach(function (root) {
      var inputs = root.querySelectorAll('input[type=range]');
      var mult = parseFloat(root.getAttribute('data-mult')) || 1;
      function paint(input) {
        var p = (input.value - input.min) / (input.max - input.min) * 100;
        input.style.setProperty('--p', p + '%');
      }
      function calc() {
        var cost = parseFloat(root.querySelector('[name=cost]').value);
        var sell = parseFloat(root.querySelector('[name=sell]').value);
        var units = parseInt(root.querySelector('[name=units]').value, 10);
        var invest = cost * units, revenue = sell * units, profit = revenue - invest;
        var roi = invest > 0 ? Math.round(profit / invest * 100) : 0;
        var fmt = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
        root.querySelector('[data-o=cost]').textContent = '$' + cost;
        root.querySelector('[data-o=sell]').textContent = '$' + sell;
        root.querySelector('[data-o=units]').textContent = units;
        root.querySelector('[data-o=profit]').textContent = fmt(profit);
        root.querySelector('[data-o=invest]').textContent = fmt(invest);
        root.querySelector('[data-o=revenue]').textContent = fmt(revenue);
        root.querySelector('[data-o=roi]').textContent = roi + '%';
        inputs.forEach(paint);
      }
      inputs.forEach(function (i) { i.addEventListener('input', calc); });
      calc();
      void mult;
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-dt-pdp]').forEach(function (root) {
      var dataEl = root.querySelector('[data-dt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var mult = parseFloat(root.getAttribute('data-mult')) || 1.6;
      var idInput = root.querySelector('input[name=id]');
      var btns = root.querySelectorAll('[data-dt-add]');
      var priceEl = root.querySelector('[data-dt-price]');
      var compareEl = root.querySelector('[data-dt-compare]');
      var resaleEl = root.querySelector('[data-dt-resale]');
      var profitEl = root.querySelector('[data-dt-profit]');
      var labelAdd = root.getAttribute('data-label-add');
      var labelOut = root.getAttribute('data-label-out');
      var labelPick = root.getAttribute('data-label-pick');
      var wa = root.querySelectorAll('[data-dt-wa]');
      var waBase = root.getAttribute('data-wa-text') || '';

      /* Galería */
      var main = root.querySelector('[data-dt-main]');
      root.querySelectorAll('[data-dt-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('[data-dt-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = 0;
          var src = t.getAttribute('data-src'), srcset = t.getAttribute('data-srcset');
          setTimeout(function () { main.src = src; if (srcset) main.srcset = srcset; main.style.opacity = 1; }, 150);
        });
      });

      /* Cantidad */
      var q = root.querySelector('[data-dt-qty] input');
      root.querySelectorAll('[data-dt-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-dt-step'), 10));
          q.value = v;
        });
      });

      /* Variantes */
      var fieldsets = root.querySelectorAll('[data-dt-option]');
      function current() {
        var sel = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var out = fs.querySelector('[data-dt-optval]');
          if (out) out.textContent = c ? c.value : '—';
        });
        if (sel.indexOf(null) > -1) return null;
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
      }
      function update() {
        if (!fieldsets.length) return;
        var v = current();
        btns.forEach(function (b) {
          if (!v) { b.disabled = true; b.textContent = labelPick; }
          else if (!v.available) { b.disabled = true; b.textContent = labelOut; }
          else { b.disabled = false; b.textContent = labelAdd; }
        });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        var resale = Math.ceil(v.price * mult / 100) * 100 - 1;
        if (resaleEl) resaleEl.textContent = money(resale);
        if (profitEl) profitEl.textContent = '+' + money(resale - v.price);
        wa.forEach(function (a) {
          var txt = waBase + ' — Talla: ' + v.title;
          a.href = a.href.split('?')[0] + '?text=' + encodeURIComponent(txt);
        });
        if (history.replaceState) {
          var url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      update();

      /* Barra fija en móvil */
      var sticky = root.querySelector('[data-dt-sticky]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(form);
        var sb = sticky.querySelector('[data-dt-add]');
        if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  function init() { initReveal(); initParallax(); initCalc(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
